export function centsToDollars (cents) {
  cents = String(cents)
  return `${cents.substring(0, cents.length - 2)}.${cents.substring(cents.length - 2)}`
}